import { Pipe, PipeTransform } from '@angular/core';
import { StatusProdutoBeneficiario as Status } from '../../models/beneficiario/StatusProdutoBeneficiario';

@Pipe({
  name: 'badgeStatusProdutoBeneficiario',
})
export class BadgeStatusProdutoBeneficiarioPipe implements PipeTransform {
  transform(status: Status): string {
    const statuses = {
      [Status.AguardandoComunicacaoComProvedor]: 'bg-warning text-dark',
      [Status.AguardandoAtivacaoNoProvedor]: 'bg-warning text-dark',
      [Status.Ativo]: 'bg-success',
      [Status.AguardandoBloqueio]: 'bg-warning text-dark',
      [Status.Bloqueado]: 'bg-danger',
      [Status.Recusado]: 'bg-danger',
    };

    return statuses[status];
  }
}
